import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectBuilderId = (state: IApplicationState) => {
  const { builderInfo } = selectNewbuilding(state);

  return builderInfo ? builderInfo.realtyUserId : null;
};
